import { PermissionRow, UserPermissions } from '@capturi/core'
import { t } from '@lingui/macro'

export const getQAPermissions = ({
  defaultRolePermissions,
  permissions,
  enableText,
  enableQualityAssurance,
  isArchiveOrg,
}: {
  defaultRolePermissions: Partial<UserPermissions>
  permissions: UserPermissions
  enableText: boolean
  enableQualityAssurance: boolean
  isArchiveOrg: boolean
}): PermissionRow[] => {
  const rows: PermissionRow[] = [
    {
      name: t`Scores`,
      key: 'editScore',
      description: t`Permission to create, edit and delete scores.`,
      disabled:
        permissions.editEverything || defaultRolePermissions?.editScore == null, // if user can editEverything, disable editing of editScore
      tooltip: t`Upgrade to get access to full quality assurance`,
      hidden: enableText || isArchiveOrg,
    },
    {
      name: t`Review Conversations`,
      key: 'qualityAssurance',
      description: t`Permission to review conversations and answer questionnaires.`,
      disabled:
        permissions.editEverything ||
        defaultRolePermissions?.qualityAssurance == null, // if user can editEverything, disable editing of qualityAssurance
      hidden: enableText || isArchiveOrg,
    },
    {
      name: t`Templates`,
      key: 'editQuestionnaire',
      description: t`Permission to create, edit and delete questionnaires.`,
      disabled:
        permissions.editEverything ||
        defaultRolePermissions?.editQuestionnaire == null ||
        !enableQualityAssurance, // if user can editEverything, disable editing of editQuestionnaire
      tooltip: t`Upgrade to get access to full quality assurance`,
      tooltipStonlyTag: 'user-permissions-qa-bolt-icon',
      hidden: enableText || isArchiveOrg,
      forcedIsChecked: enableQualityAssurance ? undefined : false,
    },
    // TODO: add back in when we have the QA Reports flag
    // {
    //   name: t`QA reports`,
    //   key: 'viewReports',
    //   description: t`Permission to see aggregated QA results in QA reports`,
    //   disabled:
    //     permissions.editEverything ||
    //     defaultRolePermissions?.viewReports == null, // if user can editEverything, disable editing of editTemplate
    //   hidden: enableText,
    //tooltip: t`Upgrade to get access to full quality assurance`
    // },
  ]

  return rows.filter((d) => !d.hidden)
}
